import { render } from "./UploadWithPreview.vue?vue&type=template&id=6ea396a4&ts=true"
import script from "./UploadWithPreview.ts?vue&type=script&lang=ts&external"
export * from "./UploadWithPreview.ts?vue&type=script&lang=ts&external"

import "./UploadWithPreview.vue?vue&type=style&index=0&id=6ea396a4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__